import { Navigate } from 'react-router-dom';
import { HelpInbox } from '@/components/help/help-inbox';
import { useOrgContext } from './layout';

/** Help requests members sent to this organization: its admins; parent admins read only. */
export function OrgHelpPage() {
  const { org, canManage, role } = useOrgContext();
  if (!canManage && role !== null) return <Navigate to=".." replace />;
  return <HelpInbox scope={{ kind: 'org', orgId: org.id }} />;
}
